import React from "react";
import Components from "../../components";
import settings from "./settings";
import { useNavigate } from "react-router-dom";

const AccountDetail = ({ data, dataSetter }) => {
  const navigate = useNavigate();
  const onBackClick = () => {
    navigate("/account");
  };
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        label="Page Header"
        title="Hesap Ayarları"
        onBackClick={onBackClick}
        extendedSettings={settings}
      />
      <Components.AccountDetail
        id="account-detail"
        label="Account Detail"
        data={data}
        dataSetter={dataSetter}
      />
    </div>
  );
};

export default AccountDetail;
